export default "<p>\n  good-chart3 works!\n</p>\n"